import React, { useState } from 'react';
import './AIEditModal.css';
import { mdiCreation } from '@mdi/js';
import Icon from '@mdi/react';


function AIEditModal({ isOpen, onClose, selectedText, onSubmit, isProcessing }) {
  const [instruction, setInstruction] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!instruction.trim()) return;
    
    onSubmit(instruction);
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="ai-edit-modal-overlay">
      <div className="ai-edit-modal">
        <div className="ai-edit-modal-header">
          <h3>AI Assistant</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="ai-edit-modal-body">
          <div className="selected-text-section">
            <h4>Selected Text</h4>
            <div className="selected-text-display">
              {selectedText || <span>No text selected. The entire content will be edited.</span>}
            </div>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="instruction-section">
              <h4>Instructions for AI</h4>
              <textarea
                value={instruction}
                onChange={(e) => setInstruction(e.target.value)}
                placeholder="Tell the AI what changes you want to make to the text. For example: 'Make this paragraph more concise' or 'Add more emotional language'"
                rows={5}
                disabled={isProcessing}
              />
            </div>
            
            <div className="buttons-section">
              <button 
                type="button" 
                className="cancel-button" 
                onClick={onClose}
                disabled={isProcessing}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="submit-button"
                disabled={!instruction.trim() || isProcessing}
              >
                {isProcessing ? (
                  <>
                    <span className="spinner"></span>
                    Processing...
                  </>
                ) : <><Icon style={{transform: 'scale(0.8)'}} path={mdiCreation} size={1} /> Send to AI</>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AIEditModal;
